module.exports = __webpack_public_path__ + "static/media/check.3d2dd24c.svg";